/**
 * Helper function to warn when a prop that should remain constant is mutated.
 *
 * Props that are used in lifecycle hooks like `mounted` or `created` should not
 * change after initialization, as those hooks only run once. If such props change,
 * the component may not react properly to the change.
 *
 * Use this function in a watch statement to detect and warn about such mutations:
 *
 * @example
 * ```typescript
 * watch: {
 * 	constantProp: () => throwIfConstantPropMutated("constantProp");
 * }
 * ```
 *
 * @param propName - The name of the prop that should remain constant
 */
export function throwIfConstantPropMutated(propName: string): void {
	throw new Error(`Prop "${propName}" was mutated after component initialization. This is not allowed, since this prop is marked as constant (non-reactive).`);
}
